import { DonationCategory } from "../Payment/constant";

export const radharaniKitchenSeva = [
"Krishna is most pleased when He honours foodstuff prepared by Srimati Radharani. Receive the blessings of Sri Sri Radha Krishna by signing up for Radharani Kitchen Seva.",
"Once Saint Durvasa blessed Srimati Radharani (the eternal consort of Krishna) as follows, “Radha, may the grains You cook taste sweeter than nectar and may anyone you eats them be blessed with a long life span”. Thus, Mother Yasoda, Krishna’s mother, invited Srimati Radharani to cook for Krishna as this would nourish Him physically with good health and spiritually with the transcendental love of His devotee, Srimati Radharani.",
"Krishna is most pleased when He honours foodstuff prepared by Srimati Radharani and every kitchen where foodstuffs are cooked for the Deities is a representation of the kitchen of Radharani.",
"Any food items you offer under Radharani’s Kitchen seva, will utilised in the Deity kitchen to prepare various food offerings to the Deities.",];

export const donationCategories: DonationCategory[] = [
    {
      title: "RadharaniKithchenSeva",
      donations: [
        { id: 1, title: "1 Day Fruit Seva", amount: 1000 },
        { id: 2, title: "2 Days Vegetable Seva", amount: 2000 },
        { id: 3, title: "3 Days Ghee Seva", amount: 3000 },
        { id: 4, title: "5 Days Anna Seva", amount: 5000 },
        { id: 5, title: "1 Day Milk Seva", amount: 7000 },
        { id: 6, title: "All Seva for 1 Day", amount: 11000 },
        { id: 7, title: "3 Days Milk Seva", amount: 21000 },
        { id: 8, title: "All Seva for 3 Days", amount: 31000 },
        { id: 9, title: "All Seva for 5 Days", amount: 51000 },
        { id: 10, title: "15 Days Milk Seva", amount: 100000 },
        { id: 11, title: "1 Month Milk Seva", amount: 200000 },
        { id: 12, title: "All Seva for 1 Month", amount: 300000 },
        { id: 13, title: "2 Months Milk Seva", amount: 400000 },
        { id: 14, title: "All Seva for 50 Days", amount: 500002 },
      ],
    },
  ];
  